<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="150px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="首页背景图片" prop="indexPageBackground">
            <el-upload
              :action="QNUploadURL"
              :data="uploadToken"
              :limit="1"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
              class="avatar-uploader"
              :on-success="handleIndexSuccess"
              :on-remove="image_remove"
              :show-file-list="false"
            >
              <img v-if="form.indexPageBackground" class="avatar" :src="form.indexPageBackground" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>建议尺寸 750px * 550px</span>
          </el-form-item>
          <el-form-item label="关于我们背景图片" prop="homePageBackground">
            <el-upload
              :action="QNUploadURL"
              :data="uploadToken"
              :limit="1"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
              class="avatar-uploader"
              :on-success="handleHomeSuccess"
              :on-remove="image_remove"
              :show-file-list="false"
            >
              <img v-if="form.homePageBackground" class="avatar" :src="form.homePageBackground" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>建议尺寸 750px * 500px</span>
          </el-form-item>
          <el-form-item label="关于我们" prop="homePageText">
            <tinymce-editor
              :height="460"
              :value="form.homePageText"
              @inputChange="inputChange"
            ></tinymce-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { setupConfig, getConfig, } from '@/api/settings'
  import { QNUploadURL, QNHost } from '@/config/net.config'
  import { getUploadToken } from '@/api/app'
  export default {
    name: 'SettingsBasic',
    data() {
      return {
        QNUploadURL,
        uploadToken:'',
        labelPosition: 'right',
        form: {
          indexPageBackground: '',
          homePageBackground: '',
          homePageText: '',
        },
        rules: {},
      }
    },
    async mounted() {
      this.getData()
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    methods: {
      handleIndexSuccess(res, file) {
        if (!res.hash) {
          this.$message.error('图片上传失败')
          return
        }
        this.form.indexPageBackground = `${QNHost}/${res.hash}`
      },
      handleHomeSuccess(res, file) {
        if (!res.hash) {
          this.$message.error('图片上传失败')
          return
        }
        this.form.homePageBackground = `${QNHost}/${res.hash}`
      },
      inputChange(value) {
        this.form.homePageText = value
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return (isJPG || isPNG) && isLt2M
      },
      async getData() {
        const config = await getConfig({key: 'GALLARY'})
        const {
          homePageBackground = '',
          homePageText = '',
          indexPageBackground = ''
        } = config && config.basic || {}
        this.form = {
          homePageBackground,
          homePageText,
          indexPageBackground
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            const config = await setupConfig({
              key: 'GALLARY',
              ...this.form
            })
            this.$message.success('保存设置成功')
          } else {
            this.$message.success('保存设置失败')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-form-item__content {
      .el-rate {
        display: inline-block;
        font-size: 0;
        line-height: 1;
        vertical-align: middle;
      }

      .el-transfer__buttons {
        padding: 10px 10px 0 10px;
      }
    }
  }
  :deep(.el-upload) {
    border: 1px dashed #81878f;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .job-avatar {
    width: 335px;
    height: 252px;
    display: block;
  }
</style>
